var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-chart',{attrs:{"title":_vm.title,"tickets":_vm.tickets,"loaded":_vm.loaded,"status-list":_vm.statusListAccess,"search-key":"room"}})}
var staticRenderFns = []

export { render, staticRenderFns }